import gsap from 'gsap'
import Swiper, { Navigation } from 'swiper'

class Insights {
  constructor() {
    if (document.querySelector('.post-type-archive-insight')) {
      this.Insights()
    }
  }

  Insights() {
    Swiper.use([Navigation])
    new Swiper('.insightsPress__swiper', {
      navigation: {
        nextEl: '.insightsPress__next',
        prevEl: '.insightsPress__prev',
      },
      watchSlidesProgress: true,
      slidesPerView: 1.4,
      spaceBetween: 20,
      breakpoints: {
        763: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    })

    window.almDone = function () {
      gsap.to(document.querySelector('.alm-btn-wrap'), {
        alpha: 0,
        duration: 0.5,
      })
    }
  }
}

export default Insights
